module.exports = __webpack_public_path__ + "static/media/mockup-mobile.a27b5f79.svg";